import type { ReactElement } from 'react';
import { Fragment } from 'react';

import { CurrencyConnected } from '../../../../../currency/CurrencyConnected';
import { L12nText } from '../../../../../text/L12nText';

import { BlackjackCardTableResult } from './BlackjackCardTableResult';

import styles from './BlackjackTableResult.module.css';

interface IBlackjackHand {
  bet: number;
  card: string[];
  doubledDown: string;
  net: number;
  number: string;
  split: string;
  score: string;
  betbehind: IBlackjackHand;
}

interface IBlackjackSeat {
  name: string;
  dealer: string;
  hand: IBlackjackHand | IBlackjackHand[];
  number: string;
  insurance: number;
  insurancPayOff: number;
}

interface BlackjackResultProps {
  seats: IBlackjackSeat[];
  tableClass: string;
}

const names: Record<string, string> = {
  '-1': 'BETBEHIND',
  '0': 'MAINBET',
  '1': 'HAND2',
  '2': '21+3',
  '3': 'PERFECT_PAIRS_SIDEBETS',
};

export default function BlackjackTableResult({ seats, tableClass }: BlackjackResultProps): ReactElement {
  const bets = seats.filter((item) => item.dealer == 'false');
  return (
    <table className={tableClass}>
      {bets.map((bet, index) => (
        <Fragment key={index}>
          <tr className={styles.caption}>
            <td colSpan={3} className={styles.caption_col}>
              <div className={styles.seat}>
                <L12nText tk="SEAT" /> {7 - Number(bet.number)}
                <BlackjackCardTableResult cards={bet.hand instanceof Array ? bet.hand[0].card : bet.hand.card} />{' '}
                {bet.hand instanceof Array ? bet.hand[0].score : bet.hand.score}
              </div>
            </td>
          </tr>
          {(bet.hand instanceof Array ? bet.hand : [bet.hand]).map((hand: IBlackjackHand) => (
            <>
              <tr>
                <td>
                  {(hand.betbehind ? hand.betbehind : hand).split === 'false' ? (
                    <L12nText tk={names[hand.number]} />
                  ) : (
                    <L12nText tk="HAND1" />
                  )}
                </td>
                <td>
                  <CurrencyConnected value={(hand.betbehind ? hand.betbehind : hand).bet} />
                </td>
                <td className={(hand.betbehind ? hand.betbehind : hand).net > 0 ? styles.win : undefined}>
                  <CurrencyConnected value={(hand.betbehind ? hand.betbehind : hand).net} />
                </td>
              </tr>
              {hand.doubledDown == 'true' && (
                <tr>
                  <td>
                    <L12nText tk="DOUBLEBET" />
                  </td>
                  <td>
                    <CurrencyConnected value={hand.bet / 2} />
                  </td>
                  <td className={hand.net > 0 ? styles.win : undefined}>
                    <CurrencyConnected value={hand.net / 2} />
                  </td>
                </tr>
              )}
            </>
          ))}
          {bet.insurance && bet.insurance > 0 && (
            <tr>
              <td>
                <L12nText tk="INSURANCE" />
              </td>
              <td>{bet.insurance}</td>
              <td className={bet.insurancPayOff > 0 ? styles.win : undefined}>{bet.insurancPayOff}</td>
            </tr>
          )}
        </Fragment>
      ))}
    </table>
  );
}
